export default __webpack_public_path__ + "static/media/installation.10df4617.jpg";